const id_whs_returnsup = {
    "": "retur pemasok",
    detail: "detail retur pemasok",
}

export default id_whs_returnsup;